import { app } from '@packages/app';
import { useMemo } from 'react';

export const useApp = <ClassDefinition extends { new (...args: any[]): any }>(
    classDefinition: ClassDefinition,
): InstanceType<ClassDefinition> => {
    return useMemo<InstanceType<ClassDefinition>>(
        () => app<InstanceType<ClassDefinition>>(classDefinition || 'app'),
        [''],
    );
};
